import React from 'react'
import CampaignWizard from '../../campaign-wizard/CampaignWizard'

function CreateEmail() {
    const steps = [
        { id: 1, title: 'Select Template', subtitle: 'Choose a template or start blank', component: 'TemplateSelection' },
        { id: 2, title: 'Campaign Information', subtitle: 'Basic information', component: 'CampaignInformation' },
        { id: 3, title: 'Subject Line', subtitle: 'Subject Line for Email', component: 'SubjectLine' },
        { id: 4, title: 'Content', subtitle: 'Main content of the email', component: 'EmailContent' },
        { id: 5, title: 'Patient List', subtitle: 'Select patient that will receive email', component: 'PatientList' },
        { id: 6, title: 'Complete', subtitle: 'Process the Campaign', component: 'Complete' }
    ]

    const handleSubmit = (formData) => {
        console.log('Form submitted:', formData)
        // Navigate back to list page
        window.history.back()
    }

    return (
        <CampaignWizard
            title="Create New Email Blast"
            description="Communicate with patient using email."
            navigatePath="/blast/email"
            campaignType="email"
            steps={steps}
            onSubmit={handleSubmit}
        />
    )
}

export default CreateEmail